import { render } from "./PublishDiffBlock.vue?vue&type=template&id=7259ff28"
import script from "./PublishDiffBlock.vue?vue&type=script&lang=js"
export * from "./PublishDiffBlock.vue?vue&type=script&lang=js"

import "./PublishDiffBlock.vue?vue&type=style&index=0&id=7259ff28&lang=css"

import exportComponent from "/codebuild/output/src2517490718/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__